import {
  connect
} from 'react-redux';

import TeamMemberDetailIndex from '../../components/Clients/EditClientProfile/TeamMemberDetail';
import {
  clearSuspendError,
  getAccountManage, getClientAssignments, getClientRoles, getRoles, getTableList, reassingAccountManager,
  rollBackReassign, rollBackUpdateStatus,
  updateRole
} from "../../actions/employees";
import {callApi} from "../../actions/Api";

const mapStateToProps = (state) => {
  const {tableList, account_manager, roles, clientRoles, ifUpdateRoleSuccess, client_assignments, ifReassignSuccess, suspend_error, client_assignments_error, team_member_options} = state.employees;
  const {clients, roleId, roleName} = state.app;
  return {
    roles : (roleId > 50) ? clientRoles : roles,
    tableList,
    ifUpdateRoleSuccess,
    // roleId,
    // userId,
    roleName,
    suspend_error,
    account_manager: account_manager.filter((item) => item.id !== 53 ),
    client_assignments,
    ifReassignSuccess,
    client_assignments_error,
    team_member_options,
    clients,
    // selected_client: (clients !== undefined && isAdminSelect) && clients[0].id
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getRoles: () => {
      dispatch(getRoles());
    },
    getClientRoles: () =>{
      dispatch(getClientRoles())
    },
    updateRole: (userId, roleId) => {
      dispatch(updateRole(userId, roleId))
    },
    rollBackUpdateStatus: () => {
      dispatch(rollBackUpdateStatus())
    },
    getTableList: (obj, clientId) => {
      dispatch(getTableList(obj, clientId));
    },
    getAccountManage: (id) => {
      dispatch(getAccountManage(id));
    },
    suspendUser: (userId, status) => {
      // just for the '/edit/Client-Team-Members/detail'
      // when use `system administrator` log in
      dispatch(function (dispatch, getState) {
        let url = `users/${userId}/${status}/client`

        callApi(dispatch, getState, 'SUSPEND_USER', url, {
          method: 'POST'
        })
      })

    },
    getClientAssignments: (id) => {
      dispatch(getClientAssignments(id))
    },
    reassingAccountManager: (id, obj) => {
      dispatch(reassingAccountManager(id, obj))
    },
    rollBackReassign: () => {
      dispatch(rollBackReassign())
    },
    clearSuspendError: () => {
      dispatch(clearSuspendError())
    }
  }
}


const TeamMemberDetail = connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamMemberDetailIndex);

export default TeamMemberDetail


// WEBPACK FOOTER //
// ./src/containers/Clients/editTeamMemberDetail.js